module.exports = "<p>\n  faqs works!\n</p>\n"